import log from 'loglevel';
import { useParams } from 'react-router-dom';
import { useAuth } from './useAuth';

const TAG = '[USE_PAGE_VIEW_MODE]';

/**
 * routeParam = input/requested view mode from URL (user-friendly)
 * permissions = required permissions to see this view mode
 * viewMode = final view-mode enum value to use in our components (not-so-user-friendly)
 */
export type PageViewMode = {
  routeParam: string,
  permissions: string[],
  viewMode: ViewMode,
};

export const usePageViewMode = (pageViewModes: PageViewMode[]): ViewMode | null => {
  const params = useParams();
  const { hasPermissions } = useAuth();

  const pageMode = pageViewModes.find((mode) => (mode.routeParam === params.viewMode));

  if (!pageMode) {
    log.debug(TAG, 'page mode does not exist:', params.viewMode);

    return null;
  }

  if (!hasPermissions(pageMode.permissions)) {
    log.debug(TAG, 'no permissions for requested page mode', {
      pageMode: params.viewMode,
      requiredPermissions: pageMode.permissions,
    });

    return null;
  }

  return pageMode.viewMode;
};
